import { render, staticRenderFns } from "./PanelIconsGrid.vue?vue&type=template&id=088f3416&scoped=true"
import script from "./PanelIconsGrid.vue?vue&type=script&lang=ts"
export * from "./PanelIconsGrid.vue?vue&type=script&lang=ts"
import style0 from "./PanelIconsGrid.vue?vue&type=style&index=0&id=088f3416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f3416",
  null
  
)

export default component.exports